import { Interface } from '@ethersproject/abi'
import { MaxUint256 } from '@ethersproject/constants'
import { ERC20_ABI, DELAY_ADDRESS, ChainId, toToken } from '../constants'
import { Currency, Pair } from '../model'
import { getStakingAddress, StakingOption } from '../pages/token/staking/utils'
import { TransactionInfo } from '../providers/transactions/model'

function getApproveTx(address: string, spenderAddress: string, txInfo: TransactionInfo) {
  return {
    to: address,
    data: new Interface(ERC20_ABI).encodeFunctionData('approve', [spenderAddress, MaxUint256]),
    txInfo,
  }
}

export function getApproveTokenForStakingTx(currency: Currency, chainId: ChainId, stakingOption: StakingOption) {
  return getApproveTx(
    toToken(currency).address,
    getStakingAddress(stakingOption, chainId),
    getApproveTokenTxInfo(currency)
  )
}

export function getApproveTokenForDelayTx(currency: Currency, chainId: ChainId) {
  return getApproveTx(toToken(currency).address, DELAY_ADDRESS[chainId], getApproveTokenTxInfo(currency))
}

export function getApprovePairForDelayTx(pair: Pair, chainId: ChainId) {
  const txInfo = {
    type: 'APPROVE_LIQUIDITY',
    symbol0: pair.getToken0Symbol(),
    symbol1: pair.getToken1Symbol(),
  } as const
  return getApproveTx(pair.address, DELAY_ADDRESS[chainId], txInfo)
}

function getApproveTokenTxInfo(currency: Currency) {
  return {
    type: 'APPROVE',
    symbol: currency.symbol,
  } as const
}
